var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-layout"},[_c('Header'),_c('EvenProgress'),_c('EventAside'),_c('div',{staticClass:"page-wrapper max-w"},[_c('EventBar'),_c('div',{staticClass:"page-inner"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }